module.exports = __webpack_public_path__ + "img/up.336b60f8.svg";